import { Dispatch } from 'redux';

import { getChainPrivateApi } from '#/api/apiCoreSdk';
import { getActiveChainFromState } from '#/reduxState/exchange/exchangeActiveChain';
import { isChainListed } from '#/reduxState/exchange/exchangeActiveChainUtils';
import { staticDispatch } from '#/reduxState/store';
import { ReduxActions } from '#/reduxState/storeCore';

import { setNoticesFromServer } from './noticesReducer';
import { NotificationBarState } from './noticesReducerUtilsPure';

// export { getChainNoticeId };

export async function fetchAndDispatchNotices(
  dispatch: Dispatch<ReduxActions> = staticDispatch
) {
  const activeChain = getActiveChainFromState();
  if (!isChainListed(activeChain)) {
    console.warn('Notices - legacy chain');
    return;
  }
  try {
    const notices = await getChainPrivateApi(activeChain).getNotices();
    dispatch(setNoticesFromServer(notices, activeChain));
  } catch (err) {
    console.warn('[API ERROR] | Failed to Get Notices from API: ', err);
  }
}

export function getNotices(
  state: NotificationBarState,
  type: 'banners' | 'notifications'
  // _chain: Chains
) {
  return type === 'notifications'
    ? state.notificationsGlobal
    : state.bannersGlobal;
  // return state[getChainNoticesPropertyName(type, chain)];
}
